import { toQuality } from '@studio/models/net/quality';
import { useUnmount } from '@studio/react-utils/hooks';
import { isNotNil } from '@tryiris-ai/js-types';
import { useEffect } from 'react';
// import { MessageIds } from './constants.js';
import { isVideoDevice } from '#~/device/index.js';
// import * as Notifications from '#~/notifications/index.js';
import { useRoom } from '#~/room/hooks.js';

/** `<Network>` component. */
export const Network = (): null => {
  // For all of the video devices, determine the worst-case network quality.
  const quality = useRoom(({ devices }) =>
    toQuality(
      Math.min(
        ...Object.values(devices)
          .map((device) => (isVideoDevice(device) ? device.video.network : Number.MAX_VALUE))
          .filter(isNotNil)
      )
    )
  );

  useEffect(() => {
    if (quality !== 'poor') {
      // Notifications.hide(MessageIds.network);

      return;
    }

    // if (!Notifications.has(MessageIds.network)) {
    //   Notifications.post({
    //     id: MessageIds.network,
    //     message:
    //       'Your internet bandwidth is low which may cause your video sources to not display. Check your network quality, or try lowering the resolution or bitrate of your sources.',
    //     severity: 'error',
    //     title: 'Internet bandwidth low'
    //   });
    // }
  }, [quality]);

  useUnmount(() => {
    // Notifications.hide(MessageIds.network);
  });

  return null;
};
